import src from "IMAGE";
export default { src, width: 144, height: 42, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADmQ//5Flfv6CS9dbQ4QEUQSFBVMCgsMJw8QET0TFRZIAC6K//5KmPv6CS9dbw0PEEcPEBJPDA0OQA4PED8QEhNGsgkRnhDVwMEAAAAASUVORK5CYII="};
